module.exports = __webpack_public_path__ + "static/robesnmore-detail-6574ae14d38175ac35035da9387fb067.png";